import { render, staticRenderFns } from "./homeIndex.vue?vue&type=template&id=a2173a7e&scoped=true"
import script from "./homeIndex.vue?vue&type=script&lang=js"
export * from "./homeIndex.vue?vue&type=script&lang=js"
import style0 from "./homeIndex.vue?vue&type=style&index=0&id=a2173a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2173a7e",
  null
  
)

export default component.exports